import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import {
  requestTranscriptionEnablement,
  requestTranscriptionDisablement,
} from "@/Services/TherapyApi/Customers";
import TranscriptionTransformer, {
  type TranscriptionTransformerType,
} from "@/Modules/Transformers/User/Transcription";

import useAppStore from "@/Modules/App/Store";
import useCustomerStore from "@/Modules/Customers/Store";

import { hasValue } from "@/Utils/Objects";

async function requestTranscriptionAH(isTranscriptionEnableRequested: boolean): Promise<boolean | undefined> {
  const appStore = useAppStore();
  const customerStore = useCustomerStore();

  if (!hasValue(customerStore.getCurrentCustomer)) return false;

  try {
    const transcriptionApi = isTranscriptionEnableRequested
      ? await requestTranscriptionEnablement(customerStore.getCurrentCustomer.id)
      : await requestTranscriptionDisablement(customerStore.getCurrentCustomer.id);
    const transcriptionTransformer: TranscriptionTransformerType = TranscriptionTransformer;
    const transcriptionDomain = transcriptionTransformer.toDomain(transcriptionApi);

    customerStore.getCurrentCustomer.transcription = transcriptionDomain;

    appStore.showSnackbar({
      message: "user.settings.customer.clinical_history.transcription.saved_notification",
      type: NotificationType.SUCCESS,
    });

    return true;
  } catch (error: unknown) {
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "user.settings.customer.clinical_history.transcription.error_notificacion",
    });

    return false;
  }
}

export default requestTranscriptionAH;
